import Button from "@common/components/Button";
import Dialog from "@common/components/Dialog";
import DialogActions from "@common/components/Dialog/DialogActions";
import DialogTitle from "@common/components/Dialog/DialogTitle";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useErrorNotification } from "@common/components/Notification";
import { DialogContent, DialogContentText } from "@mui/material";
import {
  disconnectParticipant,
  disconnectReleaseParticipant,
} from "@services/meetings";
import { ConferenceParticipant } from "@services/meetings/types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type EndCallDialogProps = {
  participant?: ConferenceParticipant;
  open: boolean;
  onClose: Function;
};

const EndCallDialog = (props: EndCallDialogProps) => {
  const { participant, open, onClose } = props;
  const context = React.useContext(RoomsRealtimeContext);
  const dispatchError = useErrorNotification();
  const { t } = useTranslation();
  const [loadingRelease, setLoadingRelease] = useState<boolean>(false);
  const [loadingDisconnect, setLoadingDisconnect] = useState<boolean>(false);
  const confirmDisconnectParticipant = async (release?: boolean) => {
    try {
      if (release) {
        setLoadingRelease(true);
        await disconnectReleaseParticipant(
          context.detail?.meeting?.id,
          participant?.room?.id
        );
        await context.detail?.refetch();
        setLoadingRelease(false);
      } else {
        setLoadingDisconnect(true);
        await disconnectParticipant(
          context.detail?.meeting?.id,
          participant?.id
        );
        await context.detail?.refetch();
        setLoadingDisconnect(false);
      }
      onClose();
    } catch (e) {
      setLoadingDisconnect(false);
      setLoadingRelease(false);
      dispatchError(e);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{t("Disconnect Participant")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("Are you sure you want to disconnect this participant?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="greyed" onClick={() => onClose()}>
          Cancel
        </Button>
        {participant?.scheduled && !participant?.released && (
          <Button
            variant="outlined"
            color="greyed"
            onClick={() => confirmDisconnectParticipant(true)}
            loading={loadingRelease}
          >
            Disconnect and Release
          </Button>
        )}
        <Button
          color="error"
          onClick={() => confirmDisconnectParticipant()}
          loading={loadingDisconnect}
        >
          Disconnect
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EndCallDialog;
